module.exports = __webpack_public_path__ + "static/media/17.3abbfa69.jpg";